module.exports = "<app-header></app-header>\r\n<div class=\"wrapper\"><router-outlet></router-outlet></div>\r\n<app-footer></app-footer>\r\n"